export class FormalizeCompany {
    constructor(companyId, companyName, clientOrBUId, clientOrBUName) {
        this.companyId = companyId;
        this.companyName = companyName;
        this.clientOrBUId = clientOrBUId;
        this.clientOrBUName = clientOrBUName;
    }
}
export class FormalizeJobMatch {
    constructor(jobMatchId, jobId, requisitionId, requisitionName) {
        this.jobMatchId = jobMatchId;
        this.jobId = jobId;
        this.requisitionId = requisitionId;
        this.requisitionName = requisitionName;
    }
}
export class FormalizeRequisition {
    constructor(jobId, requisitionId, requisitionName) {
        this.jobId = jobId;
        this.requisitionId = requisitionId;
        this.requisitionName = requisitionName;
    }
}
export class FormalizeCandidate {
    constructor(candidateId, firstName, lastName) {
        this.candidateId = candidateId;
        this.firstName = firstName;
        this.lastName = lastName;
    }
}
export class FormalizeUser {
    constructor(userId, firstName, lastName, email) {
        this.userId = userId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
    }
}
export class FormalizePayload {
    constructor(data) {
        this.activityType = 'TEXT_FORMALIZATION';
        this.duration = null;
        this.dateRange = { startDate: null, endDate: null };
        this.sourceScreen = null;
        this.externalNote = null;
        this.noteId = null;
        this.company = null;
        this.jobMatch = null;
        this.requisition = null;
        this.candidate = null;
        this.user = null;
        this.originalText = null;
        this.formalizedText = null;
        this.mode = 'TEXT';
        this.tone = null;
        this.savedNote = null;
        if (data)
            Object.assign(this, data);
    }
}
//# sourceMappingURL=formalizePayload.js.map